import { render } from "./CustomerMultiSelect.vue?vue&type=template&id=804dc34c&scoped=true&ts=true"
import script from "./CustomerMultiSelect.vue?vue&type=script&lang=ts"
export * from "./CustomerMultiSelect.vue?vue&type=script&lang=ts"

import "./CustomerMultiSelect.vue?vue&type=style&index=0&id=804dc34c&lang=scss&scoped=true"

import exportComponent from "C:\\source-ali\\Order-Management\\OrderManagement-Web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-804dc34c"]])

export default __exports__